// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"422":"20a54e69","668":"922761f1"}[chunkId] + ".chunk.js";
};